import React, { Fragment } from 'react';

import SuggestionFragment from './suggestions/SuggestionFragment';
import {
    isGithubSuggestion,
    isGoogleDriveSuggestion,
    isTettraPageSuggestion,
    getAllSuggestions,
} from '../utilities/suggestionUtilities';
import { KEYCODE } from '../utilities/CONSTANTS';

class LinkSuggestions extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {
        suggestions: null,
        focusedIndex: 0,
    };

    componentDidMount() {
        this._isMounted = true;
        this.getSuggestions();
        this.props.addKeyDownEventHandler(this.onKeyDown);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.searchText !== this.props.searchText) {
            this.getSuggestions();
        }
    }

    onKeyDown = (e) => {
        const { suggestions, focusedIndex: prevIndex } = this.state;
        if (e.which === KEYCODE.upArrow) {
            e.stopPropagation();
            e.preventDefault();
            let focusedIndex = prevIndex - 1;
            focusedIndex = focusedIndex < 0 ? 0 : focusedIndex;
            this.setState({ focusedIndex });
            return true;
        } if (e.which === KEYCODE.downArrow) {
            e.stopPropagation();
            e.preventDefault();
            let focusedIndex = prevIndex + 1;
            focusedIndex = focusedIndex === suggestions.length ? focusedIndex - 1 : focusedIndex;
            this.setState({ focusedIndex });
            return true;
        } if (e.which === KEYCODE.enter) {
            if (suggestions && suggestions[prevIndex]) {
                e.stopPropagation();
                e.preventDefault();
                this.selectSuggestion(suggestions[prevIndex]);
                return true;
            }
        }
    };

    getSuggestions = () => {
        const { searchText } = this.props;

        const team = typeof window.teamId !== 'undefined' ? window.teamId : null;

        getAllSuggestions(searchText, team, 'LinkSuggestions.jsx').then(asyncSuggestions => {
            this._isMounted && this.setState({ suggestions: asyncSuggestions });
        });
    };

    selectSuggestion = (suggestion) => {
        this.props.selectSuggestion(suggestion.getUrl());
    };

    render() {
        const { suggestions, focusedIndex } = this.state;
        const { searchText } = this.props;

        return (
            <div className="suggestions internal-suggestions">
                {suggestions && suggestions.map((suggestion, index) => (
                    <div
                        key={suggestion.getId()}
                        className={focusedIndex === index ? 'focused' : ''}
                        onMouseDown={() => this.selectSuggestion(suggestion)}
                    >
                        <SuggestionFragment suggestion={suggestion} />
                    </div>
                ))}
            </div>
        );
    }
}

export default LinkSuggestions;
